import React, { useEffect, useState } from 'react';
import './AddEmailModal.scss';
import { toast } from 'react-toastify';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { ContactSolutation } from '../../../../utils/dropsdown';
import { addVendorContactPerson, updateVendorContactPerson } from '../../../../services/vendor';

function AddEmailModal({
	setIsAddContactModal,
	vendor_id,
	communicationEmail,
	setCommunicationEmail,
	emailDetail,
}) {
	const [disabled, setDisabled] = useState(false);
	const [error, setError] = useState({});
	const [formData, setFormData] = useState({
		salutation: '',
		first_name: '',
		last_name: '',
		email: '',
		work_phone: '',
		mobile: '',
		department: '',
	});

	const handleInputChange = (key, value) => {
		setFormData((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	function checkValidation() {
		const errorEmail = { ...error };
		if (
			((!formData.email || formData.email === '' || formData.email === null) &&
				(!formData.work_phone ||
					formData.work_phone === '' ||
					formData.work_phone === undefined)) ||
			(errorEmail.email && formData.email !== '')
		) {
			errorEmail.email = errorEmail.email ?? 'Please enter email address';
		} else {
			delete errorEmail.email;
		}

		if (
			((!formData.work_phone || formData.work_phone === '' || formData.work_phone === null) &&
				(!formData.email || formData.email === '' || formData.email === undefined)) ||
			(errorEmail.work_phone && formData.work_phone !== '')
		) {
			errorEmail.work_phone = errorEmail.work_phone ?? 'Please enter work phone number';
		} else {
			delete errorEmail.work_phone;
		}
		if (Object.keys(errorEmail).length > 0) {
			setError(errorEmail);
			return true;
		} else {
			return false;
		}
	}

	const addContactPerson = async () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to add email communication');
		} else {
			try {
				const data = await addVendorContactPerson(formData, vendor_id);

				setCommunicationEmail([
					...communicationEmail,
					{
						isSelected: false,
						id: data?.data?.contact_person_id,
						email: data?.data?.email,
						salutation: data?.data?.salutation,
						first_name: data?.data.first_name,
						last_name: data?.data.last_name,
						mobile: data?.data?.mobile,
						work_phone: data?.data?.work_phone,
						department: data?.data?.department,
					},
				]);
				setIsAddContactModal(false);
			} catch (error) {
				toast.error('Something went wrong');
			}
		}
	};

	const updateContactPerson = async () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to add email communication');
		} else {
			try {
				await updateVendorContactPerson(vendor_id, emailDetail?.id, formData);
				let indexEmail = communicationEmail.findIndex((contact) => contact.id === emailDetail.id);
				let emailData = [...communicationEmail];
				emailData[indexEmail] = formData;
				emailData[indexEmail].isSelected =
					formData.email !== '' && formData.email !== null && formData.email !== undefined
						? true
						: false;
				emailData[indexEmail].id = emailDetail?.id;

				setCommunicationEmail(emailData);
				setIsAddContactModal(false);
			} catch (error) {
				toast.error('Something went wrong');
			}
		}
	};

	const validateEmail = (value) => {
		const regex =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regex.test(value);
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			if (emailDetail.id) {
				updateContactPerson();
			} else {
				addContactPerson();
			}
		}
	};
	useEffect(() => {
		function handleEmailDetail() {
			setFormData({
				salutation: emailDetail?.salutation,
				first_name: emailDetail?.first_name,
				last_name: emailDetail?.last_name,
				email: emailDetail?.email,
				work_phone: emailDetail?.work_phone,
				mobile: emailDetail?.mobile,
				department: emailDetail?.department,
			});
		}
		if (emailDetail?.id) {
			handleEmailDetail();
		}
	}, []);

	return (
		<div
			className="add-contact-person"
			onKeyDown={handleKeyDown}
		>
			<div className="row">
				<div className="col">
					<InputSelect
						options={ContactSolutation || []}
						label="Salutation"
						placeholder="Salutation"
						className="vendorContact-salutation"
						onChange={(value) => {
							handleInputChange('salutation', value);
						}}
						onSelect={(options) => handleInputChange('salutation', options.value)}
						value={formData.salutation}
						disabled={disabled}
						autoFocus={true}
					/>
				</div>
				<div className="col">
					<InputField
						label="First Name"
						placeholder="First Name"
						type="text"
						value={formData.first_name}
						onChange={(value) => handleInputChange('first_name', value)}
						disabled={disabled}
						name={`new-first-name-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="new-first-name"
					/>
				</div>
				<div className="col">
					<InputField
						label="Last Name"
						placeholder="Last Name"
						type="text"
						name={`new-last-name-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="new-last-name"
						value={formData.last_name}
						onChange={(value) => handleInputChange('last_name', value)}
						disabled={disabled}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col">
					<InputField
						label="Email"
						placeholder="Email"
						type="text"
						name={`email-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="new-email"
						value={formData.email}
						onChange={(value) => {
							let errorEmail = { ...error };
							if (value) {
								if (validateEmail(value)) {
									delete errorEmail.email;
									if (
										(formData.work_phone === '' || formData.work_phone === null) &&
										errorEmail.work_phone
									) {
										delete errorEmail.work_phone;
									}
								} else {
									errorEmail.email = 'Please enter a valid email address';
								}
							} else {
								if (formData.work_phone !== '' && errorEmail.work_phone) {
									errorEmail.email = 'Please enter a valid email address';
								} else {
									delete errorEmail.email;
								}
							}
							setError(errorEmail);
							handleInputChange('email', value);
						}}
						disabled={disabled}
						error={error?.email}
					/>
				</div>
				<div className="col">
					<InputField
						label="Phone(Work)"
						placeholder="Phone No."
						type="text"
						name={`phone-work-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="phone-work"
						value={formData.work_phone}
						onChange={(valueData) => {
							let value = valueData.replace(/[^0-9]/g, '');
							let errorEmail = { ...error };
							if (value) {
								if (value.length < 11) {
									const regex = /^[1-9]\d{9}$/;
									if (regex.test(value)) {
										if (value.length === 10) {
											delete errorEmail.work_phone;
											if ((formData.email === '' || formData.email === null) && errorEmail.email) {
												delete errorEmail.email;
											}
										} else {
											errorEmail.work_phone = 'Please enter a valid Phone(Work)';
										}
									} else {
										errorEmail.work_phone = `Please enter valid Phone(Work) ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
									}
									handleInputChange('work_phone', value);
								}
							} else {
								if (formData.email !== '' && errorEmail.email) {
									errorEmail.work_phone = 'Please enter a valid Phone(Work)';
								} else {
									delete errorEmail.work_phone;
								}
								handleInputChange('work_phone', value);
							}
							setError(errorEmail);
						}}
						disabled={disabled}
						error={error?.work_phone}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputField
						label="Phone(Mobile)"
						placeholder="Phone no."
						type="text"
						name={`phone-no-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="phone-no"
						value={formData.mobile}
						onChange={(valueData) => {
							let errorEmail = { ...error };
							let value = valueData?.replace(/[^0-9]/g, '');
							if (value) {
								if (value.length < 11) {
									const regex = /^[1-9]\d{9}$/;
									if (regex.test(value)) {
										if (value.length > 10 || value.length < 10) {
											errorEmail.mobile = 'Please enter valid Phone(Mobile)';
											handleInputChange('mobile', value);
											setError(errorEmail);
										} else {
											delete errorEmail.mobile;
											setError(errorEmail);
											handleInputChange('mobile', value);
										}
									} else {
										errorEmail.mobile = `Please enter valid Phone(Mobile) ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
										setError(errorEmail);
										handleInputChange('mobile', value);
									}
								}
							} else {
								delete errorEmail.mobile;
								setError(errorEmail);
								handleInputChange('mobile', value);
							}
						}}
						disabled={disabled}
						error={error?.mobile}
					/>
				</div>
				<div className="col">
					<InputField
						label="Department"
						placeholder="Department"
						type="text"
						name={`deparment-${Math.random().toString(36).substr(2, 9)}`}
						autoComplete="deparment"
						value={formData.department}
						onChange={(value) => handleInputChange('department', value)}
						disabled={disabled}
					/>
				</div>
			</div>
			<br />

			<span className="">
				<Button
					type="button"
					className="btn-primary px-5 w-auto"
					button={emailDetail?.id ? 'Update' : 'Add'}
					onClick={() => {
						if (emailDetail.id) {
							updateContactPerson();
						} else {
							addContactPerson();
						}
					}}
				/>
			</span>
		</div>
	);
}

export default AddEmailModal;
